import { render, staticRenderFns } from "./UiFooter.vue?vue&type=template&id=4e4914e9&"
import script from "./UiFooter.vue?vue&type=script&lang=ts&"
export * from "./UiFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports